import { Maybe } from 'aem-libs-ts/src/types/utility'
import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'

import { invalidValueMessageId } from './invalidValueMessageId'

interface InvalidValueAriaProps {
  'aria-describedby': string
  'aria-invalid': boolean
}

const errorAriaProps = (showError: boolean, id: Maybe<string>): InvalidValueAriaProps | {} =>
  showError && isDefined(id) ? { 'aria-invalid': true, 'aria-describedby': invalidValueMessageId(id) } : {}

interface UseFieldErrorOptions {
  hideValidation?: boolean
}

type UseFieldErrorReturn = {
  showError: boolean
  errorMessage: string
  ariaErrorProps: Partial<InvalidValueAriaProps>
}

export const useFieldError = (
  fieldId: Maybe<string>,
  validationMessage: Maybe<string>,
  { hideValidation }: UseFieldErrorOptions
): UseFieldErrorReturn => {
  const showError = Boolean(!hideValidation && validationMessage && validationMessage.length > 0)

  return {
    showError,
    ariaErrorProps: errorAriaProps(showError, fieldId),
    errorMessage: validationMessage as string
  }
}
